var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9A\xD1\x80\xD0\xB5\xD1\x81\xD1\x82\xD0\xB8\xD0\xBA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4573",
    width: 35.5052,
    height: 3.80413,
    rx: 1.90206,
    transform: "matrix(0.708379 -0.705832 0.708379 0.705832 0.652344 25.3145)",
    fill: "#0060B7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4574",
    width: 35.5052,
    height: 3.80413,
    rx: 1.90206,
    transform: "matrix(0.708379 0.705832 -0.708379 0.705832 3.19531 0)",
    fill: "#0060B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5420e8c819b4a18a66d0ed65ca57ea6b.svg";
export { ForwardRef as ReactComponent };